<template>
	<div class="input__wrapper">
		<label  :class="{ 'focused': focused }">
			<span class="input-label" :id="data.labelId">{{ data.label }}</span>
			<div class="input-tags">
				<div class="tags">
					<div class="tags__box">
						<span class="asInput" v-for="(tag, index) in tags" @keyup.delete="backspaceDeleteEmail(index)" :key="tag.index">
							<span>{{tag}}</span>
							<span class="delete-item" @click="deleteEmail(index)">
								<SvgIcon class="delete-tag-icon" iconName="ico-close-sm"/>
							</span>
						</span>
						<transition name="fade">
							<input
								:placeholder="data.placeholder" 
								v-model="newTag"
								@blur="isBlure"
								@keydown.enter.prevent="addEmail($event)"
								:id="data.inputId"
								@keydown.delete="backspaceDelete()"
								@keydown.space.prevent="addEmail($event)"
								ref="emailInput"
								@keydown.tab.prevent="addEmail($event)"
							/>
						</transition>
					</div>
				</div>
				<div class="error-message" v-if="invalidEmail">Email must contain valid information.</div>
			</div>
		</label>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	props: {
		data: {
			type: Object,
			required: true
		},
		bcc: {
			type: Array,
			default: null
		},
		to: {
			type: Array,
			default: null
		},
		cc: {
			type: Array,
			default: null
		}
	},

	data () {
		return {
			newTag: '',
			position: 1,
			tags: [],
			focused: false,
			index: '',
			invalidEmail: false,
			type: null
		};
	},
	mounted() {
		if (this.bcc) {
			this.tags = this.bcc;
			this.type = 'bcc';
		}
		if (this.to) {
			this.tags = this.to;
			this.type = 'to';
		}
		if (this.cc) {
			this.tags = this.cc;
			this.type = 'cc';
		}
	},
	watch: {
		tags() {
			this.$emit('input', this.tags);
			if (this.tags.length > 0) {
				this.$refs.emailInput.classList.add('hidePlaceholder');
			}
		},
		bcc() {
			if (this.bcc) {
				this.tags = this.bcc;
			}
		},
		to() {
			if (this.to) {
				this.tags = this.to;
			}
		},
		cc() {
			if (this.cc) {
				this.tags = this.cc;
			}
		}
	},
	components: {
		SvgIcon
	},
	methods: {
		backspaceDeleteEmail(index) {
			this.tags.splice(index, 1);
		},
		backspaceDelete(index) {
			if (this.newTag === '') {
				this.tags.splice(index, 1);
			}
		},
		deleteEmail(index) {
			this.tags.splice(index, 1);
			this.$root.$emit('delete-email', {
				type: this.type,
				index: index
			});

			if (this.tags.length < 0) {
				console.log(this.newTag);
			}
		},
		addEmail(e) {
			const val = e.target.value;
			if (this.emailValidator(val)) {
				if (val !== '') {
					const arr = val.split(',');
					if (this.tags.length > 0) {
						const newArr = this.tags.concat(arr);
						this.tags = newArr;
					} else {
						this.tags = arr;
					}
					this.newTag = '';
				}
				this.focused = true;
				this.invalidEmail = false;
			} else {
				this.invalidEmail = true;
			}
		},
		setValue(value) {
			this.tags = value;
		},
		isBlure(e) {
			const val = e.target.value;
			this.$refs.emailInput.classList.remove('hidePlaceholder');
			this.focused = false;
			if (!this.emailValidator(this.tags) || this.tags !== '') {
				this.invalidEmail = false;
			}
			if (this.tags.length > 0) {
				this.$refs.emailInput.classList.add('hidePlaceholder');
			}
			if (val !== '' && this.emailValidator(val)) {
				const arr = val.split(',');
				if (this.tags.length > 0) {
					const newArr = this.tags.concat(arr);
					this.tags = newArr;
				} else {
					this.tags = arr;
				}
				this.newTag = '';
				this.focused = true;
				this.invalidEmail = false;
			} else if (val === '') {
				this.invalidEmail = false;
			} else {
				this.invalidEmail = true;
			}
		},
		emailValidator: function (newTag) {
			const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(newTag);
		}
	}
};
</script>

<style lang="scss" scoped>
.tags {
	display: flex;
	flex-direction: row;
	box-shadow: none;
	border: 1px solid $grey-light;
	border-radius: 8px;
	padding: 11px 19px;
	line-height: 1.2;
	width: 100%;
	font-size: 14px;
	width: 100%;
	font-family: $font-main;
	line-height: 1.2;
	color: $slate-gray;
	min-height: 48px;
	transition: $dur $ease;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	@include mq($sm) {
		font-size: 16px;
	}
	
	.asInput {
		line-height: 1;
		width: auto;
		background-color: trnasparent;
		border: 1px solid $dodger-blue;
		border-radius: 20px;
		padding: 0 10px;
		margin-right: 2px;
		margin-bottom: 5px;
		height: 24px;
		display: flex;
		color: $fiord;
		align-items: center;
		font-family: $font-main;

		span {
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-width: 200px;
			
			@include mq(400px) {
				max-width: 130px;
			}
		}
	}
	
	input {
		margin: 0;
		opacity: 1;
		transition: all .3s ease-in-out;
		border: none;
		height: auto;
		padding: 0;
		font-family: $font-main;
		min-width: 50%;
		width: auto;
		background-color: $white-lilac;
	}
}

.input__wrapper {
	margin-bottom: 20px;
}

.tags__box {
	display: flex;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 100%;
	min-width: auto;
	flex-wrap: wrap;
	margin-bottom: -5px;
	overflow: auto;
	max-height: 56px;

	&::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}

	&::-webkit-scrollbar-track {
		background: #eceeef;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #42526e;
		border-radius: 20px;
		border: 1px solid #eceeef;
	}
	scrollbar-width: thin;
	scrollbar-color: #42526e #eceeef;

	input {
		font-size: 14px;
		margin-bottom: 5px;

		@include mq($sm) {
			font-size: 16px;
		}
	}
}

.tags__wrap {
	display: flex;
	flex-wrap: wrap;
}

input::-webkit-input-placeholder { /* Chrome/Opera/Safari */
	color: #bdbdbd;
}
input::-moz-placeholder { /* Firefox 19+ */
	color: #bdbdbd;
}
input:-ms-input-placeholder { /* IE 10+ */
	color: #bdbdbd;
}
input:-moz-placeholder { /* Firefox 18- */
	color: #bdbdbd;
}

.focused {
	.tags {
		border: 1px solid $dodger-blue;
	}

}

input::-webkit-input-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input:-moz-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input::-moz-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}
input:-ms-input-placeholder {
	opacity: 1;
	width: 100%;
	transition: $dur $ease;
}

.input-tags {
	position: relative;
	border: 1px solid $white-lilac;
	background-color: $white-lilac;
	border-radius: 14px;
}

.delete-item {
	padding: 0;
	position: relative;
	margin-left: 5px;
	line-height: 1;
	height: 13px;

	&::before {
		content: '';
		background-color: $white;
		width: 1px;
		height: 95%;
		left: -2px;
		top: 50%;
		transform: translateY(-50%);
		position: absolute;
		z-index: 3;
	}
}

.delete-tag-icon {
	font-size: 10px;
	color: $fiord;
	height: 14px;
	/deep/ svg {
		height: 100%;
	}
}

.error-message {
	bottom: -19px;
	position: absolute;
	display: inline-block;
	transform: none;
}
</style>
